import { useEffect, useState } from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Server, AlertCircle } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';

export function ServerAlertModal({ isOpen, onContinue }) {
  const [countdown, setCountdown] = useState(5);
  const [canContinue, setCanContinue] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setCountdown(5);
      setCanContinue(false);

      const timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            setCanContinue(true);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [isOpen]);

  return (
    <AlertDialog open={isOpen}>
      <AlertDialogContent className="w-[80%] max-w-[500px] max-h-[85vh] overflow-y-auto">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2 text-xl">
            <Server className="h-6 w-6 text-primary" />
            Peringatan Penting!
          </AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-4 pt-2">
              <Alert className="border-primary/50 bg-primary/10">
                <AlertCircle className="h-5 w-5 text-primary" />
                <AlertDescription className="text-sm ml-2 text-foreground">
                  <strong className="font-semibold">WAJIB BERADA DI DALAM SERVER</strong>
                  <br />
                  Setelah pembayaran selesai, benefit akan diberikan secara OTOMATIS kepada player yang sedang online di server.
                </AlertDescription>
              </Alert>

              <div className="space-y-3 p-4 rounded-lg border border-border bg-card">
                <h4 className="font-semibold text-sm text-foreground">Pastikan kamu:</h4>
                <ul className="space-y-2 text-sm text-muted-foreground">
                  <li className="flex items-start gap-2">
                    <span className="text-primary mt-0.5">•</span>
                    <span>Sudah join ke server <strong className="text-foreground">play.hytale-id.net</strong></span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-primary mt-0.5">•</span>
                    <span>Tetap online di server selama proses pembayaran</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-primary mt-0.5">•</span>
                    <span>Program akan otomatis memberikan rank/benefit setelah pembayaran diterima</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-primary mt-0.5">•</span>
                    <span>Jika ada masalah, segera hubungi staff di Discord</span>
                  </li>
                </ul>
              </div>

              <div className="p-3 rounded-lg bg-yellow-500/10 border border-yellow-500/30">
                <p className="text-xs text-yellow-700 dark:text-yellow-500">
                  ⚠️ Jika kamu tidak berada di server saat pembayaran selesai, benefit mungkin tidak langsung diterima dan kamu harus menghubungi staff.
                </p>
              </div>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction 
            onClick={onContinue}
            disabled={!canContinue}
            className="w-full sm:w-auto"
          >
            {canContinue ? (
              'Saya Mengerti, Lanjutkan'
            ) : (
              `Tunggu ${countdown} detik...`
            )}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
